import { StateService } from '@/core/services/state.service';
import { Component, Input } from '@angular/core';
import { AnfrageDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { PortalContextService } from '../../../../services/portal-context.service';
import { AnfrageService } from '@/api/service-index';

@Component({
  selector: 'review-anfrage-infoarea',
  templateUrl: './review-anfrage-infoarea.component.html',
  styleUrls: ['./review-anfrage-infoarea.component.scss']
})
export class ReviewAnfrageInfoareaComponent {

  @Input() anfrage: AnfrageDisplayModel | undefined | null = null
  @Input() showBereich: boolean = true
  @Input() showAusschreibung: boolean = true
  @Input() showPhase: boolean = true
  @Input() showChat:boolean = true;

  public get showAnfrageInfo() {
    return this.stateService.showAnfrageInfo;
  }

  constructor(protected stateService: StateService, protected portalContextService: PortalContextService, protected anfrageService: AnfrageService) { 
    //
  }

  onToggleClick() {
    this.stateService.ToggleAnfrageInfo();
  }

  validationOnLanguageChangeFunction(){
    const id: string = this.portalContextService.CurrentItemContext?.id;
    if (id) {
      this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.portalContextService.CurrentAnfrage.id, gutachtenId: id}).subscribe(response => {
        this.stateService.ValidationErrors = response;
      });
    }
  }
}
